import { render, staticRenderFns } from "./BrandedAppLayout.vue?vue&type=template&id=1abb7b10&"
import script from "./BrandedAppLayout.vue?vue&type=script&lang=js&"
export * from "./BrandedAppLayout.vue?vue&type=script&lang=js&"
import style0 from "./BrandedAppLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports